import { sha256 } from "js-sha256";
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
    }
    AnalyticsService.getInstance = function () {
        if (!AnalyticsService.instance) {
            AnalyticsService.instance = new AnalyticsService();
        }
        return AnalyticsService.instance;
    };
    //
    //
    // GENERIC USER INTERACTION
    //
    //
    AnalyticsService.prototype.dtmGenericUserInteraction = function (uivalue) {
        if (typeof dataLayer != "undefined") {
            dataLayer.userInteraction = uivalue;
            if (typeof _satellite == "object") {
                _satellite.track("genericUserInteraction");
            }
        }
    };
    //
    //
    // Records the form feld failure upon submit (i.e. client side)
    //
    //
    AnalyticsService.prototype.dtmFormFieldsValidationFail = function (fields) {
        if (typeof dataLayer != "undefined") {
            dataLayer.formFieldsErrors = fields;
            dataLayer.siteErrorCode =
                "client side | user failed on form fields";
            if (typeof _satellite == "object") {
                _satellite.track("sendSiteErrorCode");
            }
        }
    };
    // For SHA256 hashing the Email and Phone number
    AnalyticsService.prototype.SHA256ContactAndEmail = function (value) {
        var hash = sha256.create();
        hash.update(value);
        hash.hex();
        return hash.toString();
    };
    //
    //
    // Trigger Ajax Form Complete
    // @status -  "complete" or "declined"
    // @leadID - lead id linked to the form complete
    //
    AnalyticsService.prototype.dtmFormComplete = function (status, leadID, submitted, leadStatus, email_sha256, hashed_msisdn) {
        if (leadID === void 0) { leadID = ""; }
        if (submitted === void 0) { submitted = false; }
        if (leadStatus === void 0) { leadStatus = ""; }
        if (email_sha256 === void 0) { email_sha256 = ""; }
        if (hashed_msisdn === void 0) { hashed_msisdn = ""; }
        if (status && typeof dataLayer != "undefined") {
            dataLayer.formStatus = status;
            dataLayer.formisSubmitted = submitted;
            dataLayer.leadID = leadID;
            dataLayer.application.applicationID = leadID;
            if (email_sha256 != "undefined" && email_sha256 != "") {
                dataLayer.email_sha256 =
                    this.SHA256ContactAndEmail(email_sha256);
            }
            if (hashed_msisdn != "undefined" && hashed_msisdn != "") {
                dataLayer.hashed_msisdn =
                    this.SHA256ContactAndEmail(hashed_msisdn);
            }
            if (leadStatus) {
                dataLayer.leadStatus = leadStatus;
            }
            if (typeof _satellite == "object") {
                _satellite.track("globalFormComplete");
            }
        }
    };
    AnalyticsService.prototype.dtmFormStart = function () {
        if (typeof dataLayer != "undefined") {
            if (typeof _satellite == "object") {
                _satellite.track("globalFormStart");
            }
        }
    };
    AnalyticsService.prototype.dtmFormNameUpdate = function (name) {
        if (name && typeof dataLayer != "undefined") {
            dataLayer.formName = name;
        }
    };
    AnalyticsService.prototype.dtmFormAbandon = function () {
        if (typeof _satellite == "object") {
            _satellite.track("globalFormAbandon");
        }
    };
    //
    //
    // force a form start on inputs that are hidden or being interacted by a slider for example
    // @field - has to be the form element html element
    //
    AnalyticsService.prototype.dtmTriggerFormStart = function (field) {
        if (typeof formtracker !== "undefined") {
            formtracker.trigger(field, "change");
        }
    };
    //
    //
    // force a form start on inputs that are hidden or being interacted by a slider for example
    // @field - has to be the form element html element
    //
    AnalyticsService.prototype.dtmRecordSiteError = function (error) {
        if (typeof dataLayer != "undefined") {
            dataLayer.siteErrorCode = error;
            if (typeof _satellite == "object") {
                _satellite.track("sendSiteErrorCode");
            }
        }
    };
    //
    //
    // Allow form to be restarted
    // Usually done if a form is being reused
    //
    AnalyticsService.prototype.dtmAllowFormRefresh = function () {
        if (typeof formtracker !== "undefined") {
            formtracker.refresh();
            formtracker.restartForm();
        }
    };
    //
    //
    // allow the capturing of 1 dropdown element
    //
    AnalyticsService.prototype.dtmFormNameChange = function (pFormName) {
        if (typeof dataLayer != "undefined" && pFormName) {
            dataLayer.formDropdownName = pFormName;
        }
    };
    //
    //
    // Allow form to be restarted
    // Usually done if a form or calculator needs to be restarted (i.e. allowing users to trigger start upon next interaction)
    //
    AnalyticsService.prototype.dtmRestartForm = function () {
        if (typeof formtracker !== "undefined") {
            formtracker.restartForm();
        }
    };
    AnalyticsService.prototype.getDtmVisitorID = function () {
        var visitorId = "";
        if (typeof _satellite == "object") {
            try {
                if (_satellite.getVisitorId()) {
                    visitorId = _satellite
                        .getVisitorId()
                        .getMarketingCloudVisitorID();
                }
            }
            catch (error) {
                console.log("Marketing Cloud Visitor ID not found");
            }
        }
        return visitorId;
    };
    //
    //
    // Allow videoPlayerTracker to detect new created videos
    //
    AnalyticsService.prototype.dtmVideoTrackerAutoSpot = function () {
        if (typeof videoPlayerTracker !== "undefined") {
            videoPlayerTracker.autoSpotYTVideos();
        }
    };
    // The analytics team would like to start tracking data about quotes that are provided on the website. This will mostly be used for forms that make use of the PowerCurve solution but can also be used on any application.
    // This will be fired off before the api is called
    AnalyticsService.prototype.startDtmApplication = function (pApplicationName, pProductName) {
        if (typeof dataLayer !== "undefined") {
            dataLayer.application.applicationName = pApplicationName; // application:<<product family>>:<<product name>>
            dataLayer.application.applicationOfferValue = "";
            dataLayer.application.applicationID = "";
            dataLayer.application.applicationStart = true;
            dataLayer.application.applicationComplete = false;
            dataLayer.application.applicationProduct = pProductName;
            if (typeof _satellite === "object") {
                _satellite.track("globalApplicationStart");
            }
        }
    };
    // This will be fired upon the response of the api before a callmeback is captured
    AnalyticsService.prototype.offerDtmApplication = function (pOfferValue, pAppRef) {
        if (pAppRef === void 0) { pAppRef = null; }
        if (typeof dataLayer !== "undefined") {
            dataLayer.application.applicationOfferValue = pOfferValue;
            dataLayer.application.applicationID = pAppRef;
            if (typeof _satellite === "object") {
                _satellite.track("globalApplicationOfferMade");
            }
        }
    };
    // This will be fired before application complete if the response from the api is positive
    AnalyticsService.prototype.approvedDtmApplication = function () {
        if (typeof dataLayer !== "undefined") {
            dataLayer.application.applicationStatus = "approved";
            if (typeof _satellite === "object") {
                _satellite.track("globalApplicationApproved");
            }
        }
    };
    // This will be fired before application complete if the response from the api is negative
    AnalyticsService.prototype.rejectedDtmApplication = function (pCode, pDescription) {
        if (typeof dataLayer !== "undefined") {
            dataLayer.application.applicationStatus = "rejected";
            dataLayer.siteErrorCode = "business error | " + pDescription + " | rule:" + pCode;
            if (typeof _satellite === "object") {
                _satellite.track("globalApplicationReject");
                _satellite.track("sendSiteErrorCode");
            }
        }
    };
    // This will be fired if the user opts to use fill in the callmeback, or if there is an automated process to add the leads to a database it will be called after processing the response data from the API
    AnalyticsService.prototype.completeDtmApplication = function () {
        if (typeof dataLayer !== "undefined") {
            dataLayer.application.applicationStart = false;
            dataLayer.application.applicationComplete = true;
            if (typeof _satellite === "object") {
                _satellite.track("globalApplicationComplete");
            }
        }
    };
    // form complete for check eligbility
    AnalyticsService.prototype.dtmFormCompleteEligibility = function (status, leadID, submitted, leadStatus) {
        if (leadID === void 0) { leadID = ""; }
        if (submitted === void 0) { submitted = false; }
        if (leadStatus === void 0) { leadStatus = ""; }
        if (status && typeof dataLayer != "undefined") {
            dataLayer.formStatus = status;
            dataLayer.formisSubmitted = submitted;
            dataLayer.leadID = leadID;
            if (leadStatus) {
                dataLayer.leadStatus = leadStatus;
            }
            if (typeof _satellite == "object") {
                _satellite.track("globalFormComplete");
            }
        }
    };
    // productView implementation for WEM and Salesforce
    AnalyticsService.prototype.dtmProductView = function () {
        if (typeof dataLayer !== "undefined") {
            if (typeof _satellite === "object") {
                _satellite.track("productView");
            }
        }
    };
    // productView implementation for WEM and Salesforce
    AnalyticsService.prototype.dtmProductViewDetails = function (category, family, sku, interestRate, term, monthlyRepayment, productStatus) {
        if (typeof dataLayer !== "undefined") {
            if (typeof _satellite === "object") {
                dataLayer.ecommerce.product = [
                    {
                        category: category,
                        family: family,
                        sku: sku,
                        interestRate: interestRate,
                        term: term,
                        monthlyRepayment: monthlyRepayment,
                        productStatus: productStatus,
                    },
                ];
                _satellite.track("productView");
            }
        }
    };
    return AnalyticsService;
}());
export { AnalyticsService };



//////////////////
// WEBPACK FOOTER
// ./services/analytics.service.ts
// module id = 3
// module chunks = 0